exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3c3yi{margin-bottom:11px !important}\n", ""]);

// Exports
exports.locals = {
	"row-before-restore-button": "_3c3yi",
	"rowBeforeRestoreButton": "_3c3yi"
};